import { render, staticRenderFns } from "./StudySummaryPanel.vue?vue&type=template&id=b84204f8&scoped=true&lang=pug&"
import script from "./StudySummaryPanel.vue?vue&type=script&lang=ts&"
export * from "./StudySummaryPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudySummaryPanel.vue?vue&type=style&index=0&id=b84204f8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84204f8",
  null
  
)

export default component.exports